<script setup lang="ts">
import { useNuxtApp } from 'nuxt/app';

import useConfig from '~/composables/useConfig.ts';
import useSimpleHead from '~/composables/useSimpleHead.ts';
import { shortForVariant } from '~/src/buildPronoun.ts';

definePageMeta({
    translatedPaths: (config) => {
        if (!config.pronouns.enabled || !config.pronouns.null || !config.pronouns.null.routes) {
            return [];
        }
        return withPronounPrefixesWithVariant(config, config.pronouns.null.routes);
    },
});

const { $translator: translator } = useNuxtApp();
const route = useRoute();
const variant = route.meta.variant as string;
const config = useConfig();

if (!config.pronouns.enabled || !config.pronouns.null) {
    throw new Error('config.pronouns.null is disabled');
}

useSimpleHead({
    title: `${translator.translate('pronouns.intro')}: ${shortForVariant('null', variant, translator)}`,
    description: translator.translate('pronouns.null.description'),
    banner: `api/banner${route.path.replace(/\/$/, '')}.png`,
}, translator);
</script>

<template>
    <Page v-if="config.pronouns.enabled && config.pronouns.null && config.pronouns.null.routes">
        <h2>
            <Icon v="tag" />
            <T>pronouns.intro</T><T>quotation.colon</T>
        </h2>

        <section>
            <div class="alert alert-primary">
                <h2 class="text-center mb-0">
                    <strong>
                        <Spelling :text="shortForVariant('null', variant, translator)" />
                    </strong>
                </h2>
            </div>
        </section>

        <section>
            <div class="alert alert-light">
                <Icon v="info-circle" />
                <T>pronouns.null.description</T>
            </div>
        </section>

        <AdPlaceholder :phkey="['content-0', 'content-mobile-0']" />

        <section>
            <PronounsNullGenerator />
        </section>

        <Avoiding />

        <PronounGroup :pronouns="config.pronouns.null.routes" />

        <section>
            <Share :title="`${$t('pronouns.intro')}: ${shortForVariant('null', variant, translator)}`" />
        </section>

        <AdPlaceholder :phkey="['content-1', 'content-mobile-1']" />

        <Separator icon="info" />
        <section class="mb-0">
            <h2 class="h4">
                <Icon v="info-circle" />
                <T>home.whatisit</T>
            </h2>
            <T>home.about</T>
            <Homepage align="center" />
        </section>
    </Page>
</template>
